import React, { useCallback, useEffect, useMemo, useState } from "react";
import DashboardLayout from "../../../layout/Layout";
import Input from "../../../common/Input";
import { useHistory, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import Api from "../../../api/api";
import Select from "../../../common/Select";
import Button from "../../../common/Button";
import { QUIZ_ACTIVE } from "../../../utils/constants";

const initialData = {
  question: "",
  answer: "",
  clue1: "",
  highlight1: "",
  clue2: "",
  highlight2: "",
  clue3: "",
  highlight3: "",
  video: "",
  date: "",
};

const AdminQuizAdd = () => {
  const { id } = useParams();
  const isNew = useMemo(() => id === "_new", [id]);
  const history = useHistory();
  const [isDisable, setIsDisable] = useState(false);
  const [show, setShow] = useState(false);
  const [data, setData] = useState({ ...initialData });

  const handleChange = e => {
    const { name, value } = e.target;
    setData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setIsDisable(true);
    try {
      const res = isNew
        ? await Api.addQuiz({ ...data, isNew: true })
        : await Api.updateQuiz(id, { ...data });

      if (res.status === 200) {
        toast.success("Quiz added successfully!");
        history.replace("/admin/dashboard/quizes");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsDisable(false);
    }
  };

  const getQuiz = useCallback(async () => {
    const res = await Api.quizById(id);
    if (res.status === 200) {
      setData(res.data.data);
    }
  }, [setData]);

  useEffect(() => {
    if (id && !isNew) {
      getQuiz();
    }
  }, [isNew, id]);

  useEffect(() => {
    return () => {
      setData({ ...initialData });
      setIsDisable(false);
    };
  }, []);

  return (
    <DashboardLayout title={`${isNew ? "Add" : "Edit"} Quiz`}>
      <form onSubmit={handleSubmit}>
        <div className="grid gap-x-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
          <Input
            title="Question"
            name="question"
            value={data?.question}
            onChange={handleChange}
            placeholder="Question"
            required
          />
        </div>
        <div className="grid gap-x-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
          <Input
            title="Answer"
            name="answer"
            value={data?.answer}
            onChange={handleChange}
            placeholder="Answer"
            required
          />
        </div>
        <div className="grid gap-x-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
          <Input
            type={"date"}
            title="date"
            name="date"
            value={data?.date}
            onChange={handleChange}
          />
        </div>
        <div className="grid gap-x-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
          <Input
            title="Clue 1"
            name="clue1"
            value={data?.clue1}
            onChange={handleChange}
            placeholder=""
            required
          />
        </div>
        <div className="grid gap-x-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
          <Input
            title="Highlight Text Clue 1"
            name="highlight1"
            value={data?.highlight1}
            onChange={handleChange}
            placeholder=""
            required
          />
        </div>
        <div className="grid gap-x-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
          <Input
            title="Clue 2"
            name="clue2"
            value={data?.clue2}
            onChange={handleChange}
            placeholder=""
          />
        </div>
        <div className="grid gap-x-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
          <Input
            title="Highlight Text Clue 2"
            name="highlight2"
            value={data?.highlight2}
            onChange={handleChange}
            placeholder=""
          />
        </div>
        <div className="grid gap-x-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
          <Input
            title="Clue 3"
            name="clue3"
            value={data?.clue3}
            onChange={handleChange}
            placeholder=""
          />
        </div>
        <div className="grid gap-x-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
          <Input
            title="Highlight Text Clue 3"
            name="highlight3"
            value={data?.highlight3}
            onChange={handleChange}
            placeholder=""
          />
        </div>
        <div className="grid gap-x-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
          <Input
            title="Video"
            name="video"
            value={data?.video}
            onChange={handleChange}
            placeholder="Video Link"
          />
        </div>
        <br />
        <Button
          type="submit"
          disabled={isDisable}
        >
          Submit
        </Button>
      </form>
    </DashboardLayout>
  );
};

export default AdminQuizAdd;
